import { onIdTokenChanged, User } from "firebase/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { authService } from "../../firebase-config";

type AuthContextType = {
  user: User | null;
  loading: boolean;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(authService, async (currentUser) => {
      setUser(currentUser);
      setInitialized(true);
      setLoading(false);
    });

    const timeout = setTimeout(() => {
      if (!initialized) {
        setLoading(false);
      }
    }, 4000);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [initialized]);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
